export const WALL_PRINTING_SERVICE = "Wall Printing & Murals";
export const WALL_PRINTING_PATH = "/services/wall-printing/";
export const WALL_PRINTING_SMS_MESSAGE = "Hi! I’m interested in wall printing. My project is in [town], and my wall is approximately [width] × [height].";
/** Preserve this service through page-level and shared contact estimate entry points. */
export function wallPrintingServiceForEntry(pathname: string, search = "", sourcePage = ""): string {
  const requested = new URLSearchParams(search).get("service");
  return pathname.replace(/\/+$/, "") === WALL_PRINTING_PATH.replace(/\/+$/, "") || sourcePage.replace(/\/+$/, "") === WALL_PRINTING_PATH.replace(/\/+$/, "") || requested === WALL_PRINTING_SERVICE ? WALL_PRINTING_SERVICE : "";
}
export const wallPrintingFaqs = [
  {
    question: "What is wall printing?",
    answer: "Wall printing uses specialized equipment to apply digital artwork directly onto a suitable wall surface. It is a separate service from wallpaper installation or adhesive vinyl graphics."
  },
  {
    question: "How does the wall printing process work?",
    answer: "We review your wall photo, dimensions, artwork, and access, then outline the preparation and printing in your estimate. The artwork layout is approved before the agreed wall preparation and printing begin."
  },
  {
    question: "How is the cost of wall printing determined?",
    answer: "Your estimate depends on the mural dimensions, artwork preparation, wall condition, background painting, access, and setup requirements. Send a wall photo and approximate measurements so we can review the scope."
  },
  {
    "question": "Can you print my logo or artwork?",
    "answer": "We can review your logo, photograph, or digital artwork to check whether it is suitable at the intended print size. Please supply artwork you own or have permission to reproduce."
  },
  {
    "question": "Can you help if I don’t have a finished design?",
    "answer": "Send us your idea and any inspiration images. We’ll discuss available design assistance and confirm any design fees before proceeding."
  },
  {
    "question": "Does the wall need preparation?",
    "answer": "It may. We assess the wall’s condition, texture, existing coating, and background color. Repairs, smoothing, priming, or painting may be recommended and will be outlined in your estimate."
  },
  {
    "question": "Can you print on textured walls?",
    "answer": "Suitability depends on the texture, surface condition, design, and equipment requirements. Send a close-up photo so we can review the surface."
  },
  {
    "question": "How large can the mural be?",
    "answer": "We confirm the achievable print area after reviewing your wall dimensions, ceiling height, obstacles, and equipment clearance."
  },
  {
    "question": "How long does installation take?",
    "answer": "Timing depends on mural size, design, setup, and preparation. Wall repairs and painting may require a separate visit and drying time. We confirm the schedule with your estimate."
  },
  {
    "question": "Can the mural be painted over later?",
    "answer": "Printed artwork can generally be covered with an appropriate preparation, primer, and paint system. The exact steps depend on the surface and ink."
  },
  {
    "question": "Where do you offer this service?",
    "answer": "We are based in Wayne and serve projects throughout Bergen, Passaic, Morris, Essex, and Hudson counties. Contact us to confirm availability for your location."
  }
];
